import { StyleSheet } from 'react-native'
import { theme } from '../../../../theme'

export const offlineBannerStyles = StyleSheet.create({
  container: {
    backgroundColor: theme.warning,
    paddingHorizontal: 16,
    paddingVertical: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    color: theme.gray[900],
    fontSize: 13,
    fontWeight: '600',
    textAlign: 'center',
  },
})
